import { brandInfo } from "../../constant";

type MetaRoutes = "home" | "admin" | "public" | "empty";

export class MetaService {
  setTitle = (title: string, type?: MetaRoutes) => {
    let siteTitle = brandInfo.name.capital;
    let siteTagline = brandInfo.siteTagline;
    document.title =
      type === "empty"
        ? title
        : type === "admin"
        ? `${title} | ${siteTitle} Admin`
        : type === "home"
        ? `${title} | ${siteTagline}`
        : `${title} | ${siteTitle}`;
  };
  setDescription = (description: string, type?: MetaRoutes) => {
    description = "Best Car Service providers in Jaipur and Mohali";
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", description);
  };
  setKeywords = (keywords: string, type?: MetaRoutes) => {
    keywords =
      "Tyre Puncture, Car Service, Car Wheel Repair, Car Denting, Car Painting, Car Wash Services Online, Car Revival Package, Car Washing & Cleaning, Car Dry Cleaning, Battery Replacement, Jump Start, Flat tyre, Tyre Rotation, Sanitization, Deodorization, Balancing and Alignment, Car Pick and Drop Service";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", keywords);
  };
}
